import { render, staticRenderFns } from "./EnacAtplDashboardRegistrationPhases.vue?vue&type=template&id=70b18f44"
import script from "./EnacAtplDashboardRegistrationPhases.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardRegistrationPhases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports